import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="relative py-16 md:py-24 bg-accent-50/70 overflow-hidden">
      {/* 装饰光晕 */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] rounded-full bg-accent-100/40 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-primary-100/15 blur-[90px] pointer-events-none" />

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-double-quotes-l text-accent-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <span className="text-xs font-medium text-accent-700 uppercase tracking-wider">Community Voice</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Trusted by Buyers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.id}
              className="rounded-2xl p-5 md:p-6 bg-background-50 border border-background-200/80"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-300 w-6 h-6 flex items-center justify-center mb-3"></i>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {testimonials.slice(3).map((t) => (
            <div
              key={t.id}
              className={`rounded-2xl p-5 md:p-6 bg-background-50 border border-background-200/80 ${
                t.id === 5 ? 'md:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-300 w-6 h-6 flex items-center justify-center mb-3"></i>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}